<div class="input-group typeahead typeahead-transportadora" [class.with-addon-left]="withAddonLeft">
    <ng-template #typeaheadTemplate let-transportadora="item">
        <span>{{transportadora.pessoa.codigoIntegracaoErp}} - {{transportadora.pessoa.nome}}</span>
        <small class="typeahead-cliente-cnpj-cpf">{{transportadora.pessoa.nomeFantasia}} - {{transportadora.pessoa.cnpjCpf}}</small>
        <span class="badge badge-danger badge-inativa" *ngIf="isInativa(transportadora.situacao)">Inativa</span>
    </ng-template>

    <div class="input-group-prepend left" *ngIf="withAddonLeft">
        <span class="input-group-text">Transportadora</span>
    </div>
    <div class="input-group-prepend">
        <span class="input-group-text">{{entity?.pessoa?.codigoIntegracaoErp}}</span>
    </div>    
    <input
        type="text"
        class="form-control"
        #inputTypeahead

        [typeahead]="typeaheadDataSource"
        [typeaheadWaitMs]="300"
        [typeaheadItemTemplate]="typeaheadTemplate"
        typeaheadOptionField="pessoa.nome"
        [typeaheadMinLength]="2"
        [typeaheadOptionsLimit]="typeaheadOptionsLimit"
        [typeaheadScrollable]="true"
        [typeaheadOptionsInScrollableView]="typeaheadOptionsInScrollableView"
        [ngModel]="typeaheadSelected"
        (ngModelChange)="typeaheadToken = $event"
        (typeaheadOnSelect)="onSelectEntity($event)"
        (typeaheadNoResults)="onChangeTypeaheadNoResults($event)"
        (typeaheadLoading)="isLoading = $event"
        [dropup]="dropup"

        (keyup)="onKeyup($event)"
        (blur)="onBlur()"
        [class.ng-invalid]="ngControl.invalid"
        [required]="required"
        [disabled]="disabled"
        [readonly]="readonly"
        autocomplete="off"
        placeholder="Digite para pesquisar...">

    <span *ngIf="isLoading">
        <i class="fas fa-spinner fa-pulse loading-indicator"></i>
    </span>

    <div class="input-group-append">
        <button type="button" class="btn btn-light" (click)="search()"  tabindex="-1">
            <i class="fas fa-search" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn-light" (click)="clear()" tabindex="-1">
            <i class="fas fa-eraser" aria-hidden="true"></i>
        </button>
    </div>
</div>
<p class="form-text text-muted nome-fantasia-cnpj-cpf" *ngIf="entity && entity.pessoa">
    {{entity.pessoa.nomeFantasia}} - {{entity.pessoa.cnpjCpf}}
    <span class="badge badge-danger badge-inativa" *ngIf="isInativa(entity.situacao)">Inativa</span>
</p>
<p class="form-text text-muted" *ngIf="typeaheadNoResults === true">Nenhuma transportadora foi encontrada</p>

<!-- Modal de pesquisa -->
<sgt-transportadora-filter-modal
    idModal="transportadoraFilterModal"
    [situacao]="situacao"
    (selectEntity)="onSelectEntityModal($event)"
    #transportadoraFilterModal>
</sgt-transportadora-filter-modal>
